module.exports = __webpack_public_path__ + "img/rubyOnRails.6047ea01.svg";